import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('UserReportWorkspaceFilters');

export const userReportWorkspaceFilterQueries = {
  selectAll: baseQuery
};
